import {
  EducationFacilitySearch,
  SEARCH_SCHOOLS_PAGE_TITLE,
} from '../../../components/EducationFacilitySearch';

const searchSchoolsPage = {
  title: SEARCH_SCHOOLS_PAGE_TITLE,
  uiSchema: {
    // Replaces the page body, including the title
    'ui:field': EducationFacilitySearch,
    // The field shows this on the radio list. The search box shows its own error separately
    school: {
      'ui:errorMessages': {
        required: 'Select your school or training facility',
      },
    },
  },
  schema: {
    type: 'object',
    required: ['school'],
    properties: {
      school: {
        type: 'string',
      },
    },
  },
};

export default searchSchoolsPage;
